export type PerspectiveKeyPointDto = {
  title: string;
  description: string;
};

export type PerspectiveKeyPointModel = PerspectiveKeyPointDto;

export const mapPerspectiveKeyPointDtoToModel = (
  dto: PerspectiveKeyPointDto
): PerspectiveKeyPointModel => dto;
